import { render, staticRenderFns } from "./DeliveryView.vue?vue&type=template&id=57623d70&scoped=true&"
import script from "./DeliveryView.vue?vue&type=script&lang=js&"
export * from "./DeliveryView.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryView.vue?vue&type=style&index=0&id=57623d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57623d70",
  null
  
)

export default component.exports